import React from 'react';
import { FiUpload } from 'react-icons/fi';

export default function PaymentHeader({ onOpenModal }) {
    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-white/60 backdrop-blur-xl rounded-lg p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/50 mb-6 font-display">
            <div>
                <h2 className="text-2xl font-bold text-gray-900 tracking-tight font-display mb-2">Payment Center</h2>
                <p className="text-gray-500 font-medium">Manage your class deposits and track verification status.</p>
            </div>
            {/* <button
                onClick={onOpenModal}
                className="w-full md:w-auto flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95 text-sm"
            >
                <FiUpload size={18} />
                <span>UPLOAD SLIP</span>
            </button> */}
        </div>
    );
}
